<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <Modal
            :text="modalText"
            id="modal_show"
        />

        <Row type="container">
            <div v-if="getTodayPurchasesTotalAmount.amount >= 0 && purchaseCurrency" class="grid grid-cols-3 md:grid-cols-6">
                <div class="text-xl font-bold col-span-3 md:col-span-2 mt-3">
                    {{ $t('productPurchase.todayPurchasesAmount') }}
                </div>
                <div class="col-span-2 md:col-span-1 text-main font-bold text-xl ml-2 mt-3">
                    {{
                        getTotalPurchaseAmount()
                    }}
                </div>
                <div class="col-span-1 mt-3">
                    <b-form-select
                        class="border-0 mt-n1 focus:ring-0 w-20"
                        v-model="selectedCurrencyShortName">
                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                        <b-form-select-option value="USD">USD</b-form-select-option>
                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                    </b-form-select>
                </div>
            </div>

            <SearchCollapse :is-bg-white="true" :do-action="showCheckbox">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
                    <div class="md:col-span-3 btn-group btn-group-toggle flex justify-content-around" data-toggle="buttons">
                        <label class="btn btn-primary button-stat active font-bold flex align-items-center justify-content-center">
                            <input type="radio" v-model="search.isPayed" @click="search.isPayed = null" name="options" checked>{{ $t('filter.all') }}
                        </label>
                        <label class="btn btn-primary button-stat">
                            <input type="radio" v-model="search.isPayed" @click="search.isPayed = true" name="options">{{ $t('payed') }}
                        </label>
                        <label class="btn btn-primary button-stat">
                            <input type="radio" v-model="search.isPayed" @click="search.isPayed = false" name="options">{{ $t('onCredit') }}
                        </label>
                    </div>

                    <div class="md:col-span-1">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-9 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchFilters">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-9 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetProductPurchaseSearchInfo">
                        </button>
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 mt-3">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.fromPrice') }}
                        </div>
                        <b-form-input
                            v-model="search.minPrice"
                            class="focus:ring-0 border-gray-300 h-11"
                            type="number"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.toPrice') }}
                        </div>
                        <b-form-input
                            v-model="search.maxPrice"
                            class="focus:ring-0 border-gray-300 h-11"
                            type="number"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.thisTime') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="after"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.toTime') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="before"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 mt-2.5">
                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('person.givenName') }}
                        </div>
                        <b-form-input
                            v-model="search.personGivenName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('person.familyName') }}
                        </div>
                        <b-form-input
                            v-model="search.personFamilyName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>

                    <div class="position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('company.title') }}
                        </div>
                        <b-form-input
                            v-model="search.companyName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchFilters"
                        >
                        </b-form-input>
                    </div>
                </div>
            </SearchCollapse>
        </Row>
        <Row type="none" class="mt-4 mx-4">
            <table class="w-full">
                <thead class="bg-lightGray h-11">
                <tr>
                    <th v-if="canManageProducts() && isShowCheckboxes">
                        <b-form-checkbox
                            class="d-inline"
                            size="lg"
                            v-model="isSelectedAll"
                            @change="selectAll()"
                        ></b-form-checkbox>
                    </th>
                    <th class="d-none d-md-table-cell">{{ $t('id') }}</th>
                    <th class="d-none d-md-table-cell">{{ $t('supplier.title') }}</th>
                    <th>{{ $t('totalPrice') }}</th>
                    <th class="d-none d-md-table-cell">{{ $t('incomeAndOutcome.Status') }}</th>
                    <th>{{ $t('date') }}</th>
                    <th style="text-align: unset" v-if="!isShowCheckboxes">{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody v-for="(item, index) in getPurchases[0]" :key="index">
                <tr class="h-11">
                    <td v-if="canManageProducts() && isShowCheckboxes">
                        <b-form-checkbox
                            class="d-inline"
                            size="lg"
                            :value=setItemDetails(item)
                            v-model="selectedProducts"
                        ></b-form-checkbox>
                    </td>

                    <td class="d-none d-md-table-cell">{{ item.id }}</td>
                    <td class="d-none d-md-table-cell text-main font-bold">{{ supplierName(item) }}</td>
                    <td>{{
                            showCurrencyById(item.currency !== null ? item.currency.id : null, item.totalPrice)
                        }}
                    </td>
                    <td class="d-none d-md-table-cell">
                        <div :style="{'background-color': howBgColor(item)}" class="py-1 rounded w-36">{{ hasPayedText(item) }}</div>
                    </td>
                    <td>{{ dateTimeFormat(item.createdAt, false) }}</td>
                    <td v-if="!isShowCheckboxes">
                        <div class="d-flex">
                            <span
                                v-if="hasNotPayedCanceled"
                                class="pr-4"
                                style="color: #46BDA1; cursor: pointer;"
                                @click="setDetails(item)"
                            >
                                <img v-if="purchaseId === item.id && getPurchase" src="/images/down-arrow-blue.png" class="h-2.5" alt="down_arrow">
                                <img v-else src="/images/right-arrow%20-blue.png" class="h-2.5" alt="down_arrow">
                            </span>

                            <img v-if="!item.isCanceled" src="/images/edit.png" class="h-6 cursor-pointer" @click="setId(item)"  alt="down_arrow">
                        </div>
                    </td>
                </tr>
                <tr v-if="purchaseId === item.id && getPurchase" class="border-0">
                    <td v-if="isLoading" colspan="6">
                     <span
                         class="spinner-border spinner-border-sm"
                         role="status"
                         aria-hidden="true"
                     >
                     </span>
                    </td>
                    <td></td>
                    <td v-if="!isLoading" colspan="4">
                        <div>
                            <table class="w-full">
                                <thead class="h-11">
                                <tr class="text-center">
                                    <td class="font-bold px-3">{{ $t('product.title') }}</td>
                                    <td class="font-bold px-3">{{ $t('amount') }}</td>
                                    <td class="font-bold px-3">{{ $t('warehouse.title') }}</td>
                                    <td class="font-bold px-3">{{ $t('price') }}</td>
                                    <td class="font-bold px-3">{{ $t('sale.sum') }}</td>
                                </tr>
                                </thead>
                                <tbody v-for="(productPurchase, index) in getPurchase.productPurchases" :key="index">
                                <tr class="h-11">
                                    <td class="w-52">{{ productPurchase.product.name }}</td>
                                    <td>{{ parseFloat(productPurchase.amount) }}</td>
                                    <td>{{ productPurchase.warehouse.name }}</td>
                                    <td>{{ showCurrencyById(productPurchase.currency.id, productPurchase.pricePerUnit) }}</td>
                                    <td>{{ showCurrencyById(productPurchase.currency.id, productPurchase.totalPrice) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </td>
                    <td></td>
                </tr>
                <tr v-if="purchaseId === item.id && getPurchase" class="border-0">
                    <td v-if="!isLoading" colspan="6">
                        <div class="grid grid-cols-2 my-3 gap-3 mx-3">
                            <div class="position-relative card h-10">
                                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                                    {{ $t('payed') }}
                                </div>

                                <div class="mt-2">{{ showCurrencyById(getPurchase.currency.id, getPurchase.payedAmount) }}</div>
                            </div>

                            <div class="position-relative card h-10">
                                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                                    {{ $t('debtAmount') }}
                                </div>

                                <div class="mt-2"> {{ showCurrencyById(getPurchase.currency.id, getPurchase.totalPrice - getPurchase.payedAmount) }}</div>
                            </div>

                        </div>
                        <div class="grid grid-cols-3 gap-3 mx-3 pb-3">
                            <div v-if="!getPurchase.transaction && !getPurchase.isCanceled" class="position-relative">
                                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                                    {{ $t('payDebt') }}
                                </div>

                                <b-form-input
                                    class="border-gray-300 h-10 rounded focus:ring-0"
                                    type="number"
                                    v-model.number="purchase.purchaseRePayedAmount"
                                    :max="getPurchase.totalPrice - getPurchase.payedAmount"
                                    min="0"
                                />
                            </div>

                            <div v-if="!getPurchase.transaction && !getPurchase.isCanceled" class="position-relative">
                                <SubmitRow
                                    md-size="12"
                                    class=""
                                    text="save"
                                    @click.native="updatePayment(item['@type'])"
                                    :is-disabled="
                                    getPurchase.rePayedAmount === 0 ||
                                    getPurchase.rePayedAmount === ''"
                                    :is-loading="$root.showOverlay"
                                />
                            </div>

                            <div v-if="!getPurchase.isCanceled" class="position-relative">
                                <button type="button" @click="setCancelled" class="btn rounded w-full h-10 bg-denyColor hover:bg-hoverDenyColor text-white">
                                    {{ $t('sale.transaction.cancel') }}
                                </button>
                            </div>

                            <div v-if="getPurchase.isCanceled" class="position-relative">
                                <div class="h-10 rounded bg-red-200 text-gray-700 font-bold flex align-items-center justify-content-center">{{ $t('sale.transaction.canceled') }}</div>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </Row>

        <div class="grid grid-cols-8 mx-3 mt-3">
            <div class="col-span-8 sm:col-start-5 sm:col-span-4 md:col-start-8 md:col-span-1">
                <button
                    v-if="selectedProducts.length > 0"
                    class="h-10 rounded bg-denyColor hover:bg-hoverDenyColor border-0 text-white font-bold w-full"
                    v-b-modal="'delete-product'">
                    {{ $t('delete') }}
                </button>
            </div>
        </div>

        <Modal
            text="deleteConfirmSimple"
            ok-text="yes"
            cancel-text="no"
            :is-ok-only="false"
            :id="'delete-product'"
            :on-ok-pressed="modalOk"
        />

        <div v-if="getPurchases.length === 0" class="col-12">{{ $t('noData') }}</div>


        <div class="row">
            <div class="col mt-3 ml-4">
                <Pagination
                    :search="search"
                    base-url="products/transactions"
                    :total-items="getPurchasesTotalCount"
                    method-name="searchPurchase"
                />
            </div>
        </div>

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">{{ $t('warning') }}!</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        {{ $t('sale.editSaleWarning') }}
                    </div>
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn danger" data-dismiss="modal" @click="cancel()">
                            {{ $t('yes') }}
                        </button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="setId(null)">
                            {{ $t('no') }}
                        </button>
                    </div>

                </div>
            </div>
        </div>

    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import accessMixin from "../../mixin/accessMixin";
import Pagination from "../../components/html/Pagination";
import Modal from "../../components/html/Modal";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormatting from "@/mixin/dateFormattingMixin";
import SearchCollapse from "@/components/SearchCollapse";
import currencyRateMixin from "../../mixin/currencyRateMixin";
import Row from "@/components/html/Row.vue";
import InputBox from "@/components/InputBox.vue";
import SubmitRow from "@/components/SubmitRow.vue";

export default {
    name: "ProductPurchasesList",
    components: {
        SubmitRow,
        InputBox,
        Row,
        Modal,
        Pagination,
        SearchCollapse,
    },
    mixins: [currencyFormatMixin, dateFormatting, accessMixin, currencyRateMixin],
    data() {
        return {
            isLoading: false,
            purchaseCurrency: null,
            selectedCurrencyShortName: 'UZS',
            modalText: '',
            purchaseId: null,
            item: {id: null, isCanceled: false, isPurchase: true},
            isSelectedAll: false,
            isShowCheckboxes: false,
            selectedProducts: [],
            productPurchases: [],
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'transactions'},
            ],
            search: {
                minPrice: '',
                maxPrice: '',
                personGivenName: '',
                personFamilyName: '',
                companyName: '',
                isPayed: null,
                after: '',
                before: '',
                purchaseId: null,
                page: 1
            },
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('payed'), value: true},
                {text: this.$t('onCredit'), value: false}
            ],
            purchase: {
                isPayed: false,
                rePayedAmount: '',
                purchaseRePayedAmount: '',
            },
        }
    },
    computed: mapGetters([
        'getProductPurchases',
        'getProductPurchasesTotalCount',
        'getPurchases',
        'getPurchasesTotalCount',
        'getTodayPurchasesTotalAmount',
        'getCurrency',
        'getPurchase'
    ]),
    methods: {
        ...mapActions([
            'setProductPurchaseDetails',
            'searchPurchase',
            'pushProductPurchaseMakeDeleted',
            'fetchPurchases',
            'setPurchaseDetails',
            'fetchTodayPurchasesTotalAmount',
            'fetchAllProductsInWarehouses',
            'setProductPurchaseCancelled',
            'setPurchaseCancelled',
            'searchProductPurchase',
            'setBreadcrumbItems',
            'fetchPurchase',
            'pushPurchaseRePayed',
            'pushProductPurchaseRePayed',
            'pushPurchaseMakePayed',
            'pushPurchaseMakeUnPayed'
        ]),
        howBgColor(item) {
            if (this.hasNotPayedCanceled(item)) {
                return this.hasNotPayedCanceled(item) ? '#FFC9D9' : '#FFF'
            }

            return this.hasNotPayed(item) ? '#FFCDB8' : '#D4F8E5'
        },
        hasNotPayed(item) {
            return item.transaction === null
        },
        hasPayedText(item) {
            if (this.hasNotPayedCanceled(item)) {
                return this.hasNotPayedCanceled(item) ? this.$t('sale.transaction.canceled') : this.$t('payed')
            }

            return this.hasNotPayed(item) ? this.$t('statistics.categories.debt') : this.$t('payed')
        },
        getTotalPurchaseAmount() {
            let totalPrice = this.calculateAmountByBaseCurrency(
                this.getTodayPurchasesTotalAmount.amount,
                this.purchaseCurrency.shortName,
                this.selectedCurrencyShortName
            )

            return this.showCurrencyWithoutSymbol(
                this.getCurrencyByShortName(this.selectedCurrencyShortName),
                totalPrice
            )
        },
        cancel() {
            this.$root.showOverlay = true

            if (!this.item.isCanceled) {
                if (this.item.isPurchase) {
                    this.setPurchaseCancelled(this.item.id)
                        .then(() => {
                            this.$i18nHelper.toUrl('products/' + this.item.id + '/purchase');
                        })
                        .catch((err) => {
                            if (err === 'Mahsulotlarning bir qismi allaqachon sotilgan') {
                                this.modalText = this.$t('error.purchaseCancel')
                            } else {
                                this.modalText = err
                            }

                            this.$bvModal.show('modal_show')
                        })
                } else {
                    this.setProductPurchaseCancelled(this.item.id)
                        .then(() => {
                            this.$i18nHelper.toUrl('products/' + this.item.id + '/purchase');
                        })
                        .catch((err) => {
                            if (err === 'Mahsulotlarning bir qismi allaqachon sotilgan') {
                                this.modalText = this.$t('error.purchaseCancel')
                            } else {
                                this.modalText = err
                            }

                            this.$bvModal.show('modal_show')
                        })
                }
            } else {
                this.$i18nHelper.toUrl('products/' + this.item.id + '/purchase');
            }
        },
        setId(purchase) {
            this.item.id = purchase.id
            this.item.isCanceled = purchase.isCanceled
            this.item.isPurchase = purchase['@type'] !== 'ProductPurchase';
        },
        setItemDetails(item) {
            return {"isPurchase": item['@type'] === 'Purchase', "itemId": item.id}
        },
        checkTransaction(item) {
            if (item.isCancelled || item.isCanceled) {
                return this.$t('sale.transaction.canceled');
            }

            return this.isPayed(item) ? this.$t('yes') : this.$t('no')
        },
        selectAll() {
            this.isSelectedAll = !this.isSelectedAll

            if (this.isSelectedAll) {
                this.getPurchases[0].map((item) => {
                    this.selectedProducts.push({isPurchase: item['@type'] === 'Purchase', itemId: item.id})
                })
            } else {
                this.selectedProducts = []
            }
        },
        showCheckbox() {
            this.isShowCheckboxes = !this.isShowCheckboxes

            if (!this.isShowCheckboxes) {
                this.selectedProducts = []
                this.isSelectedAll = false
            }
        },
        modalOk() {
            this.$root.showOverlay = true

            this.pushProductPurchaseMakeDeleted(this.selectedProducts)
                .then(() => {
                    this.search.page = this.$route.params.page === undefined ? 1 : this.$route.params.page;

                    this.fetchPurchases(this.search)
                        .then(() => {
                            this.isSelectedAll = false
                            this.selectedProducts = []
                            this.$root.showOverlay = false
                        })
                })
        },
        setDetails(item) {
            this.isLoading = true

            if (this.purchaseId === item.id) {
                this.purchaseId = 0
            } else {
                this.purchaseId = item.id
            }

            this
                .fetchPurchase(item.id)
                .then(() => {
                    this.isLoading = false
                })
                .catch(() => {
                    this.isLoading = false
                })
        },
        supplierName(item) {
            if (item.supplier === null) {
                return ''
            }

            if (item.supplier.person === null) {
                return item.supplier.supplierCompany.name
            }

            return item.supplier.person.givenName + ' ' + item.supplier.person.familyName
        },
        isPayed(item) {
            return item.transaction !== null
        },
        hasNotPayedCanceled(item) {
            return item.isCancelled === true || item.isCanceled === true
        },
        searchFilters() {
            this.$root.showOverlay = true
            this.searchPurchase(this.search)
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetProductPurchaseSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchFilters()
        },
        sortProductPurchases(purchases, prop) {
            return purchases.sort(function (a, b) {
                if (a[prop] > b[prop]) return -1;
            })
        },
        updatePayment(purchaseType) {
            this.$root.showOverlay = true

            if (purchaseType === 'Purchase') {
                this.updatePurchasePayment()
            } else {
                this.updateProductPurchasePayment()
            }
        },
        updatePurchasePayment() {
            this.isPurchase = true
            let amount = ((parseFloat(this.purchase.purchaseRePayedAmount)) + (parseFloat(this.getPurchase.payedAmount))).toString()

            if (parseFloat(amount) >= parseFloat(this.getPurchase.totalPrice)) {
                this.purchase.isPayed = true
            } else {
                this.pushPurchaseRePayed({purchaseId: this.getPurchase.id, payedAmount: parseFloat(this.purchase.purchaseRePayedAmount)})
                    .then(() => {
                        this.fetchPurchases(this.search)
                        this.$root.showOverlay = false
                    })
            }
        },
        updateProductPurchasePayment() {
            this.isPurchase = false
            let amount = ((+this.item.rePayedAmount) + (+this.getProductPurchaseDetails.payedAmount)).toString()

            if (parseFloat(amount) === parseFloat(this.getProductPurchaseDetails.totalPrice)) {
                this.item.isPayed = true
            } else {
                this.pushProductPurchaseRePayed({id: this.getProductPurchaseDetails.id, payedAmount: amount})
                    .then(() => {
                        this.$router.go(0)
                    })
            }
        },
        changePaymentState(isPayedState) {
            this.purchase.isPayed = isPayedState
            this.$root.showOverlay = true

            if (this.isPurchase) {
                this.purchaseChangePaymentState(isPayedState)
            } else {
                this.productPurchaseChangePaymentState(isPayedState)
            }
        },
        productPurchaseChangePaymentState(isPayedState) {
            if (isPayedState) {
                this.pushProductPurchaseMakePayed(this.getProductPurchaseDetails.id)
                    .then(() => {
                        this.pushProductPurchaseRePayed({
                            id: this.getProductPurchaseDetails.id,
                            payedAmount: this.getProductPurchaseDetails.totalPrice
                        })
                            .then(() => {
                                this.$router.go(0)
                            })
                    })
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.pushProductPurchaseMakeUnPayed(this.getProductPurchaseDetails.id)
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
        purchaseChangePaymentState(isPayedState) {
            if (isPayedState) {
                this.pushPurchaseMakePayed(this.getPurchase.id)
                    .then(() => {
                        this.pushPurchaseRePayed({
                            purchaseId: this.getPurchase.id,
                            payedAmount: parseInt(this.getPurchase.totalPrice)
                        })
                            .then(() => {
                                this.fetchPurchase(this.getPurchase.id)
                                    .then(() => {
                                        this.$router.go(0)
                                        this.$root.showOverlay = false
                                    })
                            })
                            .catch(() => {
                                this.fetchPurchase(this.getPurchase.id)
                                    .then(() => {
                                        this.$router.go(0)
                                        this.$root.showOverlay = false
                                    })
                            })
                    })
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.pushPurchaseMakeUnPayed(this.getPurchase.id)
                    .finally(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
        setCancelled() {
            this.$root.showOverlay = true

            if (this.getPurchase['@type'] === 'Purchase') {
                this.setPurchaseCancelled(this.getPurchase.id)
                    .then(() => {
                        this.fetchPurchases(this.search)
                        this.fetchPurchase(this.getPurchase.id)
                            .then(() => {
                                this.$root.showOverlay = false
                            })
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.setProductPurchaseCancelled(this.getProductPurchaseDetails.id)
                    .then(() => {
                        this.fetchProductPurchase(this.getProductPurchaseDetails.id)
                            .then(() => {
                                this.$root.showOverlay = false
                            })
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.isSelectedAll = false
                this.selectedProducts = []
            }
        },
        'purchase.isPayed'() {
            this.changePaymentState(this.purchase.isPayed)
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchPurchases(this.search)
            .then(() => {
                this.productPurchases = this.sortProductPurchases(this.getPurchases[0], 'createdAt');
                this
                    .fetchTodayPurchasesTotalAmount()
                    .then(() => {
                        this.purchaseCurrency = this.getCurrency(this.getTodayPurchasesTotalAmount.currency.id)
                        this.selectedCurrencyShortName = this.purchaseCurrency.shortName
                        this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true
                        this.fetchAllProductsInWarehouses()
                    })
            })
    }
}
</script>

<style scoped>

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.button-stat {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: #E5E5E5;
    color: #707070;
    height: 35px;
    width: 100px;
}

.button-stat:checked:active:focus {
    background-color: #6539B2 !important;
}

.button-stat:active {
    background-color: #6539B2 !important;
}


.btn-secondary {
    background-color: #ffffff !important;
    border: none;
    padding: 0;
}

.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

.col-1, .col-11 {
    padding: 0 !important;
}

td, th {
    text-align: center;
}

.clear {
    clear: both;
}

</style>
